import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "../api";
import {
  Box, TextField, Button, FormControlLabel, Switch, Typography, Stack, Snackbar, Alert,
} from "@mui/material";
import ImageUploader from "./ImageUploader";

const slugify = (s) =>
  s.toLowerCase().trim().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");

export default function GalleryEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [g, setG] = useState(null);
  const [toast, setToast] = useState(null);

  useEffect(() => { api.get(`/sk12_gallerymst/${id}`).then((r) => setG(r.data)); }, [id]);

  if (!g) return null;

  const save = async () => {
    await api.put(`/sk12_gallerymst/${id}`, {
      Title: g.Title,
      Slug: g.Slug || slugify(g.Title),
      Description: g.Description || null,
      CoverImageUrl: g.CoverImageUrl || null,
      IsPublished: g.IsPublished ? 1 : 0,
      SortOrder: g.SortOrder || 0,
    });
    setToast({ severity: "success", msg: "Saved" });
  };

  const remove = async () => {
    if (!window.confirm("Delete this gallery? This cannot be undone.")) return;
    await api.delete(`/sk12_gallerymst/${id}`);
    navigate("/admin", { replace: true });
  };

  return (
    <Box sx={{ maxWidth: 800 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>Edit Gallery</Typography>
      <Stack spacing={2}>
        <TextField label="Title" value={g.Title || ""}
          onChange={(e) => setG({ ...g, Title: e.target.value, Slug: g.Slug || slugify(e.target.value) })} />
        <TextField label="Slug" value={g.Slug || ""} onChange={(e) => setG({ ...g, Slug: e.target.value })} />
        <TextField label="Description" multiline minRows={3} value={g.Description || ""}
          onChange={(e) => setG({ ...g, Description: e.target.value })} />
        <FormControlLabel
          control={<Switch checked={!!g.IsPublished} onChange={(e) => setG({ ...g, IsPublished: e.target.checked })} />}
          label="Published (visible on public site)" />
        <Box sx={{ display: "flex", gap: 2 }}>
          <Button variant="contained" onClick={save}>Save</Button>
          <Button color="error" onClick={remove}>Delete</Button>
        </Box>
      </Stack>
      <Box sx={{ mt: 4 }}>
        <Typography variant="h6" sx={{ mb: 1 }}>Images</Typography>
        <ImageUploader galleryId={id} onCover={(url) => setG({ ...g, CoverImageUrl: url })} />
      </Box>
      <Snackbar open={!!toast} autoHideDuration={2500} onClose={() => setToast(null)}>
        {toast && <Alert severity={toast.severity}>{toast.msg}</Alert>}
      </Snackbar>
    </Box>
  );
}
